import React from "react";
import { useNavigate } from "react-router-dom";

const Welcome = () => {
    const navigate = useNavigate();
    return (
        <div >
            <div className="indicator-container">
                <div className="indicator selected">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
            </div>


            <div className="vivify fadeInBottom duration-500" style={{
                marginTop: '15vh'
            }}>
                <div className="image-center">
                    <img src="/assets/dad.png" alt="dad" />
                </div>
                <h1 className="large-text">Welcome To Your Recap Dad!</h1>
                <div className="large-button-container">
                    <button onClick={
                        () => {
                            navigate('/dad/spaghetti');
                        }
                    } className="large-button">
                        Let's Go!
                    </button>
                </div>
            </div>

        </div>
    );
}

export default Welcome;